import i18nextInit from 'i18n'
import * as msgTypes from 'models/iFrame/msgTypes'
import { getBaseUrl } from 'models/location/selectors'
import { getTestingEnv, getMaxTextureSize, getMemoryTrackingEnv } from 'utils/environment'
import getMaxWindowSize from 'utils/getMaxWindowSize'
import { APP_ENV_PROD, APP_ENV_TESTING } from 'models/tracking/constants'
import * as showroomsApi from 'services/showrooms'
import mwEn from '../../../locales/en/mw.json'
import mwNl from '../../../locales/nl-nl/mw.json'
import commonEn from '../../../locales/en/common.json'
import commonNl from '../../../locales/nl-nl/common.json'

const resources = {
    en: {
        mw: mwEn,
        common: commonEn,
    },
    'nl-nl': {
        mw: mwNl,
        common: commonNl,
    },
}
const i18nOptions = {
    resources,
    ns: 'mw',
    defaultNS: 'mw',
}

const LAYOUT_TYPE_GRID_2X2 = 'GRID_2X2'
const LAYOUT_TYPE_BANNER = 'BANNER'
const LAYOUT_TYPE_CARD = 'CARD'
const DEFAULT_SLOT_INDEX = 0
const DEFAULT_CATALOG = 'magicwindow'

// For testing:
// const currentPage = 'https://www.ikea.com/us/en/'
// const currentPage = 'https://www.ikea.com/us/en/?testing=true'.split('?')[0]
// const currentPage = 'https://www.ikea.com/us/en/rooms/dining/'
// const currentPage = 'https://www.ikea.com/us/en/rooms/dining/'.split('?')[0]

// Current page without the query parameters
const currentPage = window.location.href.split('?')[0]

let geoCompositionId

const onI18nError = () => {
    // eslint-disable-next-line no-console
    console.log('Error in i18n init for magic window')
}

const setDataAttributesForShowroom = (showroom, element) => {
    const { subCatalog: showroomSubCatalog, composition, scene } = showroom
    const subCatalog = showroomSubCatalog || DEFAULT_CATALOG
    if (element) {
        element.setAttribute('data-subcatalog', subCatalog)
        element.setAttribute('data-composition', composition)
        element.setAttribute('data-scene', scene)
    }
}

const setImagesSrcForShowroom = (showroomImages, ImageElements) => {
    if (ImageElements) {
        ImageElements.forEach((image, imageIndex) => {
            image.setAttribute('src', showroomImages[imageIndex])
        })
    }
}

i18nextInit(onI18nError, i18nOptions).then((t) => {
    const geoHeaderNode = document.querySelector('#GeomagicalWindowCard .geoHeader')
    if (geoHeaderNode) {
        geoHeaderNode.innerHTML = t('magicWindow.header')
    }
    const geoSubheaderNode = document.querySelector('#GeomagicalWindowCard .geoSubheader')
    if (geoSubheaderNode) {
        geoSubheaderNode.innerHTML = t('magicWindow.subheader')
    }
    const geoHeaderButtonNode = document.querySelector('#GeomagicalWindowCard .geoHeaderButton')
    if (geoHeaderButtonNode) {
        geoHeaderButtonNode.innerHTML = t('magicWindow.open magic window')
    }
    const geoCtaButtonNode = document.querySelector('#GeomagicalWindowCard .geoCtaButton .geoCtaButtonText')
    if (geoCtaButtonNode) {
        geoCtaButtonNode.innerHTML = t('magicWindow.explore this room in 3D')
    }
    const geoCardHeaderNode = document.querySelector('#GeomagicalWindowBanner .geoCardHeader')
    if (geoCardHeaderNode) {
        geoCardHeaderNode.innerHTML = t('magicWindow.furnish this space in 3D')
    }
    const geoCardSubheaderNode = document.querySelector('#GeomagicalWindowBanner .geoCardSubheader')
    if (geoCardSubheaderNode) {
        geoCardSubheaderNode.innerHTML = t('magicWindow.explore your home design')
    }
    const geoCardCtaButtonNode = document.querySelector('#GeomagicalWindowBanner .geoHeaderButton')
    if (geoCardCtaButtonNode) {
        geoCardCtaButtonNode.innerHTML = t('magicWindow.try it now')
    }

    const geoTwoByTwoHeaderNode = document.querySelector('#GeomagicalWindowTwoByTwo .geoTwoByTwoHeader')
    if (geoTwoByTwoHeaderNode) {
        geoTwoByTwoHeaderNode.innerHTML = t('magicWindow.dining room furniture to mix-and-match')
    }
    const geoTwoByTwoSubheaderNode = document.querySelector('#GeomagicalWindowTwoByTwo .geoTwoByTwoSubheader')
    if (geoTwoByTwoSubheaderNode) {
        geoTwoByTwoSubheaderNode.innerHTML = t('magicWindow.dining room subheader')
    }
    const geoTwoByTwoHeaderButtonNode = document.querySelector('#GeomagicalWindowTwoByTwo .geoHeaderButton')
    if (geoTwoByTwoHeaderButtonNode) {
        geoTwoByTwoHeaderButtonNode.innerHTML = t('magicWindow.start your 3D design')
    }
    const geoTwoByTwoCtaButtonNodes = document.querySelectorAll(
        '#GeomagicalWindowTwoByTwo .geoCtaButton .geoCtaButtonText',
    )
    if (geoTwoByTwoCtaButtonNodes) {
        geoTwoByTwoCtaButtonNodes.forEach(
            // eslint-disable-next-line no-param-reassign
            (ctaButtonnode) => (ctaButtonnode.innerHTML = t('magicWindow.explore this room in 3D')),
        )
    }

    showroomsApi
        .getShowrooms(currentPage)
        .then(({ data: showRoomsApiData }) => {
            if (showRoomsApiData && showRoomsApiData.length) {
                const { layout, showrooms } = showRoomsApiData[DEFAULT_SLOT_INDEX]
                const firstShowroom = showrooms[0]

                if (layout === LAYOUT_TYPE_GRID_2X2) {
                    const grid2x2 = document.querySelector('#GeomagicalWindowTwoByTwo')

                    const validShowrooms = showrooms.reduce(
                        (acc, thisShowroom) => acc && !!thisShowroom.scene && !!thisShowroom.composition,
                        true,
                    )
                    if (grid2x2 && validShowrooms) {
                        const headerWrapper = grid2x2.querySelector('.geoHeaderContainer .geoStartMagicWindow')
                        setDataAttributesForShowroom(firstShowroom, headerWrapper)

                        const mwRooms = grid2x2.querySelectorAll('.geoShowRooms .geoRoom')
                        if (mwRooms) {
                            mwRooms.forEach((mwRoom, roomIndex) => {
                                const images = mwRoom.querySelectorAll('.geoImageContainer .geoHero')
                                setImagesSrcForShowroom(showrooms[roomIndex].images, images)

                                const roomWrapper = mwRoom.querySelector('.geoStartMagicWindow')
                                setDataAttributesForShowroom(showrooms[roomIndex], roomWrapper)
                            })
                        }

                        grid2x2.style.display = 'block'
                    }
                }
                if (layout === LAYOUT_TYPE_BANNER) {
                    const banner = document.querySelector('#GeomagicalWindowBanner')

                    // This layout type should only have one showroom
                    const validShowroom = firstShowroom.scene && firstShowroom.composition
                    if (banner && validShowroom) {
                        const textWrapper = banner.querySelector('.geoCardTextContainer .geoStartMagicWindow')
                        const imagesWrapper = banner.querySelector('.geoCardImagesWrapper .geoStartMagicWindow')
                        const images = banner.querySelectorAll('.geoImageContainer .geoHero')

                        setDataAttributesForShowroom(firstShowroom, textWrapper)
                        setDataAttributesForShowroom(firstShowroom, imagesWrapper)
                        setImagesSrcForShowroom(firstShowroom.images, images)

                        banner.style.display = 'block'
                    }
                }
                if (layout === LAYOUT_TYPE_CARD) {
                    const card = document.querySelector('#GeomagicalWindowCard')

                    // This layout type should only have one showroom
                    const validShowroom = firstShowroom.scene && firstShowroom.composition
                    if (card && validShowroom) {
                        const headerWrapper = card.querySelector('.geoHeaderContainer .geoStartMagicWindow')
                        const bodyWrapper = card.querySelector('.geoBodyContainer.geoStartMagicWindow')
                        const images = card.querySelectorAll('.geoImageContainer .geoHero')

                        setDataAttributesForShowroom(firstShowroom, headerWrapper)
                        setDataAttributesForShowroom(firstShowroom, bodyWrapper)
                        setImagesSrcForShowroom(firstShowroom.images, images)

                        card.style.display = 'block'
                    }
                }
            }
        })
        // eslint-disable-next-line no-console
        .catch((err) => console.log('Error in Magic Window showrooms : ', err))
})

const isTestingEnv = getTestingEnv()
const maxTextureSize = getMaxTextureSize()
const memoryTrackingEnv = getMemoryTrackingEnv()

function trackGoogleAnalytics(action, label, options = {}) {
    if (window.sendEvent) {
        window.sendEvent({
            ...options,
            AppEnvironment: isTestingEnv ? APP_ENV_TESTING : APP_ENV_PROD,
            event_category: 'magic_window',
            event_action: action,
            event_label: label,
        })
    }
}

function makeModalWidth() {
    const iframeElement = document.getElementById('GeomagicalIFrame')
    iframeElement.classList.remove('fullWidth')
    iframeElement.classList.add('modalWidth')
}

function makeFullWidth() {
    const iframeElement = document.getElementById('GeomagicalIFrame')
    iframeElement.classList.add('fullWidth')
    iframeElement.classList.remove('modalWidth')
}

function closeMagicWindow() {
    document.getElementById('GeomagicalModal').style.display = 'none'
    const iframeElement = document.getElementById('GeomagicalIFrame')
    iframeElement.classList.remove('modalWidth')
    iframeElement.classList.remove('fullWidth')

    const scrollY = document.body.style.top
    document.body.style.position = ''
    document.body.style.top = ''
    window.scrollTo(0, parseInt(scrollY || '0', 10) * -1)

    trackGoogleAnalytics('close', geoCompositionId)
}

function doGetTokens(sourceWindow) {
    if (window.ikea && window.ikea.authentication) {
        window.ikea.authentication.getTokens((error, tokens) =>
            sourceWindow.postMessage(
                {
                    type: msgTypes.GET_TOKENS_RESPONSE,
                    tokens,
                    error,
                    isDev: window.location.hostname.includes('.cte.'),
                },
                SUGARCUBE_ORIGIN,
            ),
        )
    }
}

function onMessage(message) {
    const { data = {}, origin, source } = message
    if (origin !== SUGARCUBE_ORIGIN) {
        return
    }
    const { type, action, label } = data
    switch (type) {
        case msgTypes.MAGIC_WINDOW_CLOSE: {
            closeMagicWindow()
            break
        }
        case msgTypes.MAGIC_WINDOW_LOADED: {
            trackGoogleAnalytics('load_complete', geoCompositionId)
            makeModalWidth()
            doGetTokens(message.source)
            break
        }
        case msgTypes.MAGIC_WINDOW_MODAL_SCREEN: {
            makeModalWidth()
            break
        }
        case msgTypes.MAGIC_WINDOW_FULL_SCREEN: {
            makeFullWidth()
            break
        }
        case msgTypes.MAGIC_WINDOW_GA_TRACKING: {
            trackGoogleAnalytics(action, label)
            break
        }
        case msgTypes.GET_TOKENS: {
            doGetTokens(source)
            break
        }
        default: {
            break
        }
    }
}

function openMagicWindow(event) {
    const { target } = event
    const roomWrapper = target.closest('.geoStartMagicWindow')
    const subCatalog = roomWrapper.getAttribute('data-subcatalog')
    const compositionId = roomWrapper.getAttribute('data-composition')
    const sceneId = roomWrapper.getAttribute('data-scene')

    geoCompositionId = compositionId

    const magicWindowModal = document.getElementById('GeomagicalModal')
    let magicWindowIframe = document.getElementById('GeomagicalIFrame')
    if (!magicWindowIframe) {
        magicWindowIframe = document.createElement('iframe')
        magicWindowIframe.id = 'GeomagicalIFrame'
    }
    window.addEventListener('message', onMessage)
    const canvasWidth = getMaxWindowSize()

    const optionalTestingUrlParam = isTestingEnv ? '&testing=true' : ''
    const texSizeParam = maxTextureSize ? `&maxTextureSize=${maxTextureSize}` : ''
    const memTrackingParam = memoryTrackingEnv ? `&memoryTrackingEnv=${memoryTrackingEnv}` : ''
    // eslint-disable-next-line max-len
    const urlParams = `subCatalog=${subCatalog}&canvasWidth=${canvasWidth}${optionalTestingUrlParam}${texSizeParam}${memTrackingParam}#${compositionId}/${sceneId}`

    let source = `${getBaseUrl()}/magicWindow?${urlParams}`
    if (window.location.hostname === 'localhost') {
        source = `//localhost:1080/magicWindow.html?${urlParams}`
    }
    magicWindowIframe.src = source

    magicWindowModal.appendChild(magicWindowIframe)
    magicWindowModal.style.display = 'flex'

    document.body.style.top = `-${window.scrollY}px`
    document.body.style.position = 'fixed'

    trackGoogleAnalytics('open', geoCompositionId)
}

const startButtons = document.querySelectorAll('.geoStartMagicWindow')
for (let i = 0, max = startButtons.length; i < max; i += 1) {
    startButtons[i].onclick = openMagicWindow
}

// To catch the browser close event
window.addEventListener('beforeunload', (event) => {
    const magicWindowModal = document.getElementById('GeomagicalModal')
    const isMagicWindowOpen = magicWindowModal.style.display === 'flex'

    if (isMagicWindowOpen) {
        // Cancel the event as stated by the standard.
        event.preventDefault()

        // Older browsers supported custom message
        // eslint-disable-next-line no-param-reassign
        event.returnValue = ''

        trackGoogleAnalytics('close', geoCompositionId, { transport_type: 'beacon' })
    }
})
